
import React, { useState } from 'react';
import { usePassword } from '@/contexts'; 
import { useResponsive } from '@/hooks/use-responsive';
import { CreatePasswordForm, ResetPasswordForm } from './password/PasswordForms';
import LockoutDisplay from './LockoutDisplay';
import PasswordStatusCard from './password/PasswordStatusCard';

const PasswordManagement = () => {
  const { hasPassword, isLocked, lockoutEndTime, clearPassword } = usePassword();
  const [showResetForm, setShowResetForm] = useState(false);
  const { isMobile } = useResponsive();

  const handleShowResetForm = () => {
    setShowResetForm(true);
  };

  const handleBackToMain = () => {
    setShowResetForm(false);
  };

  // If account is locked, show lockout message
  if (isLocked && lockoutEndTime) {
    // Convert string to Date if needed
    const lockoutDate = typeof lockoutEndTime === 'string' 
      ? new Date(lockoutEndTime)
      : lockoutEndTime;
      
    return <LockoutDisplay lockoutEndTime={lockoutDate} />;
  }

  // Show forms based on current state
  return (
    <div className="w-full max-w-lg mx-auto">
      {/* Create Password or Status Card */}
      {!showResetForm && (
        <div className="p-6 border rounded-lg shadow-sm bg-card">
          {!hasPassword ? (
            <CreatePasswordForm />
          ) : (
            <PasswordStatusCard 
              onReset={handleShowResetForm}
              onClear={() => clearPassword()}
            />
          )}
        </div>
      )}
      
      {/* Reset Password Form */}
      {showResetForm && (
        <div className="p-6 border rounded-lg shadow-sm bg-card">
          <ResetPasswordForm onBack={handleBackToMain} />
        </div>
      )}
    </div>
  );
};

export default PasswordManagement;
